import { useTranslation } from 'react-i18next';
import { Checkbox, FormControl, FormControlLabel, FormGroup, Grid, TextField, Typography } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers';

import { DD_SLASH_MMM_SLASH_YYYY } from '../../../../../../../constants/dateFormat';
import { NSPP_TRAVEL } from '../../../../../../../services/i18n/namespaces';
import { travelTimeList } from '../../EncountersSection/TravelSection/travelConstants';

export default function PreferredTravelDateAndTime({ values, errors, actions, readOnly = false }) {
  const { t } = useTranslation();
  const { setFieldValue, handleChange, handleCheckboxGroupChange } = actions;
  const { departureDate, returnDate, preferredDepartureAirport, preferredArrivalAirport, preferredTravelTime } = values;
  return (
    <Grid container spacing={2} alignItems="flex-start" sx={{ pl: '14px', pr: '14px', pt: 3 }}>
      <Grid size={12}>
        <Typography variant="subtitle2">{t(`${NSPP_TRAVEL}:travelRequests.preferredTravelDateAndTime`)}</Typography>
      </Grid>
      <Grid size="auto">
        <DesktopDatePicker
          disabled={readOnly}
          disablePast={true}
          name="departureDate"
          value={departureDate}
          timezone="system"
          onChange={function(date) {
            setFieldValue('departureDate', date);
          }}
          label={t(`${NSPP_TRAVEL}:travelRequests.departureDate`)}
          format={DD_SLASH_MMM_SLASH_YYYY}
          views={['year', 'month', 'day']}
          slotProps={{
            textField: {
              variant: 'standard',
              fullWidth: true,
              error: Boolean(errors.departureDate),
              helperText: errors.departureDate
            }
          }}
        />
      </Grid>
      <Grid size="auto">
        <DesktopDatePicker
          disabled={readOnly}
          disablePast={true}
          name="returnDate"
          value={returnDate}
          timezone="system"
          onChange={function(date) {
            setFieldValue('returnDate', date);
          }}
          label={t(`${NSPP_TRAVEL}:travelRequests.returnDate`)}
          format={DD_SLASH_MMM_SLASH_YYYY}
          views={['year', 'month', 'day']}
          slotProps={{
            textField: {
              variant: 'standard',

              fullWidth: true,
              error: Boolean(errors.returnDate),
              helperText: errors.returnDate
            }
          }}
        />
      </Grid>
      <Grid size="auto">
        <TextField
          disabled={readOnly}
          name="preferredDepartureAirport"
          value={preferredDepartureAirport}
          onChange={handleChange}
          fullWidth
          label={t(`${NSPP_TRAVEL}:travelRequests.preferredDepartureAirport`)}
          variant="standard"
          autoComplete="off"
          slotProps={{
            htmlInput: { maxLength: 100 }
          }}
        />
      </Grid>
      <Grid size="auto">
        <TextField
          disabled={readOnly}
          name="preferredArrivalAirport"
          value={preferredArrivalAirport}
          onChange={handleChange}
          fullWidth
          label={t(`${NSPP_TRAVEL}:travelRequests.preferredArrivalAirport`)}
          variant="standard"
          autoComplete="off"
          slotProps={{
            htmlInput: { maxLength: 100 }
          }}
        />
      </Grid>
      <Grid size="grow"></Grid>
      <Grid size={12}>
        <FormControl disabled={readOnly} component="fieldset" variant="standard">
          <FormGroup row>
            {travelTimeList.map(function({ id, name }) {
              return (
                <FormControlLabel
                  key={id}
                  sx={{ margin: 0 }}
                  control={
                    <Checkbox
                      checked={preferredTravelTime.includes(id)}
                      onChange={handleCheckboxGroupChange}
                      value={id}
                      name="preferredTravelTime"
                    />
                  }
                  label={t(`${NSPP_TRAVEL}:preferredTravelTime.${name}`)}
                />
              );
            })}
          </FormGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
}
